<script>
    export let icon;
    export let colour = "black";
    import { onMount } from 'svelte';

    let iconImage;

    onMount(async () =>{
        iconImage = (await import(`./img/${icon}.svg`)).default

        // console.log(iconImage)
    });
    
</script>

<svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask-{icon}">
    {@html iconImage}
  </mask>
  <rect fill={colour} x="0" y="0" width="100" height="100" mask="url(#mask-{icon})"/>
</svg>
